export default "__VITE_ASSET__7c761009__"